import { PencilIcon } from "@heroicons/react/outline";
import imageCompression from "browser-image-compression";
import cx from "classnames";
import React, { useContext, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { firebase, logout, storage } from "../constants/firebase";
import { makeid } from "../constants/utils";
import { UserContext } from "../containers/UserProvider";

export const AccountPage = ({ closeModal }) => {
  const db = firebase.firestore();
  const user = useContext(UserContext);
  const [username, setUsername] = useState(user?.username);
  const [imageLoading, setImageLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    setImageUrl(user.imageUrl);
  }, [user]);

  const onDrop = async (acceptedFiles) => {
    for (let i = 0; i < acceptedFiles?.length; i++) {
      const image = acceptedFiles[i];
      setImageLoading(true);

      let newImage = image;

      if (image.type === "image/heic") {
        const heic2any = require("heic2any");
        const conversionResult = await heic2any({ blob: image });
        newImage = conversionResult;
      }
      const options = {
        maxWidthOrHeight: 400,
        maxSizeMB: 0.2,
        useWebWorker: true,
      };

      try {
        const compressedFile = await imageCompression(newImage, options);
        const ID = makeid(10);
        storage
          .ref(ID)
          .put(compressedFile)
          .then(() => {
            storage
              .ref()
              .child(ID)
              .getDownloadURL()
              .then((url) => {
                setImageUrl(url);
              });
          });
        // test
      } catch (err) {
        console.log(err);
      }
    }
    setImageLoading(false);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const onSubmit = (e) => {
    if (!username?.length) {
      alert("Please select a username");
    }

    e.preventDefault();
    db.collection("users")
      .doc(user.uid)
      .set({ username, image, imageUrl }, { merge: true });
    closeModal();
  };

  const onLogout = () => {
    logout();
    closeModal();
  };

  return (
    <div className="w-full text-white">
      <div
        {...getRootProps()}
        role="button"
        className={cx(
          "rounded-full bg-green-800 mb-4 flex items-center justify-center mx-auto",
          isDragActive ? "primary-border" : image?.length ? "" : "dottedBorder"
        )}
        style={{
          width: 100,
          height: 100,
        }}
      >
        <input {...getInputProps()} />
        {imageLoading ? (
          <p>Loading...</p>
        ) : imageUrl ? (
          <div className="relative rounded-full h-full w-full">
            <img
              alt="profile"
              src={imageUrl}
              className="mx-auto object-cover rounded-full h-full w-full"
            />
          </div>
        ) : isDragActive ? (
          <p className="p-2">Drop the photo(s) here ...</p>
        ) : (
          <div className="p-2">
            <p>add pic</p>
          </div>
        )}
      </div>
      <div>
        <form>
          <input
            className="shadow appearance-none border-gray-700 rounded w-full py-2 px-3 bg-gray-600 text-white-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            placeholder="Choose a username"
            value={username}
            required
            onChange={(e) => setUsername(e.target.value)}
          />
          <input
            className="shadow appearance-none mt-3 border-gray-700 rounded w-full py-2 px-3 bg-gray-600 text-white-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            value={user?.email}
            disabled
          />
          <button
            type="button"
            className={cx(
              username?.length
                ? "hover:bg-blue-400 bg-blue-500"
                : "bg-gray-500",
              "py-3 my-4 px-8 w-full focus:ring-blue-500 focus:ring-offset-blue-200 text-white transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg "
            )}
            onClick={onSubmit}
            disabled={!username?.length}
          >
            Save Changes
          </button>
          <button type="button" className="mb-4" onClick={onLogout}>
            Log Out
          </button>
        </form>
      </div>
    </div>
  );
};
